import { render, staticRenderFns } from "./cv-data-table.vue?vue&type=template&id=e72bde94&"
import script from "./cv-data-table.vue?vue&type=script&lang=js&"
export * from "./cv-data-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports